import { createContext } from "react";
import type { AuthContextType } from "./types";

// The context object alone, separated from the provider (index.tsx) so that
// consumers — useAuth, guards, tests — don't drag in the Amplify bootstrap
// (configs/amplify throws without the VITE_AWS_* env vars, e.g. under vitest).
export const AuthContext = createContext<AuthContextType | undefined>(undefined);
